

class PostType {
  POST = 'post'
  NOTICE = 'notice'
  TEMPLATE = 'template'
  KEYWORD = 'keyword'
  PAGE = 'page'

  isPost (type) {
    return this.POST === type;
  }

  isNotice (type) {
    return this.NOTICE === type;
  }

  isTemplate (type) {
    return this.TEMPLATE === type;
  }

  isKeyword (type) {
    return this.KEYWORD === type;
  }

  isPage (type) {
    return this.PAGE === type;
  }
}

export default new PostType();
